var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGooglePlusIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_187",
    "data-name": "Group 187",
    transform: "translate(-1370 -8651)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_184",
    "data-name": "Group 184",
    transform: "translate(1370 8651)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_76",
    "data-name": "Rectangle 76",
    width: 28,
    height: 28,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-google-plus-g",
    "data-name": "Icon awesome-google-plus-g",
    d: "M17.91,12a7.422,7.422,0,0,1,.143,1.456c0,5-3.354,8.547-8.4,8.547a8.75,8.75,0,1,1,0-17.5,8.358,8.358,0,0,1,5.861,2.292l-2.376,2.28A4.913,4.913,0,0,0,9.65,7.723a5.528,5.528,0,0,0,0,11.054A4.739,4.739,0,0,0,14.616,15H9.65V12h8.26Zm8.449.293V9.75H23.808v2.54h-2.54v2.552h2.54v2.54H26.36v-2.54H28.9V12.29H26.36Z",
    transform: "translate(1369.1 8651.75)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlusIcon);
export default __webpack_public_path__ + "static/media/google-plus-icon.b025f6a3678f2d1389aeb8341ff83bad.svg";
export { ForwardRef as ReactComponent };